import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CompactBreadcrumbModule } from "@obg/core.compact-breadcrumb";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";
import { GlobalUiLazyImageModule } from "@obg/ngx.ui.global.lazy-image";

import { FooterContainer } from "./footer.container";
import { FooterLicenseComponent } from "./license/footer-license.component";

const DIRECTIVES: any[] = [FooterContainer, FooterLicenseComponent];

@NgModule({
	imports: [
		CoreModule,
		CoreUiModule,
		CommonModule,
		GlobalUiModule,
		GlobalModule,
		CoreContentModule,
		GlobalUiLazyImageModule,
		CompactBreadcrumbModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class FooterModule {}
